import flexibleTypes from './flexible/types';
import withdrawalTypes from './withdrawal/types';

export default {
  ...flexibleTypes,
  ...withdrawalTypes,
};
